import { useEffect, useState } from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import { api } from "../ApiServices/ApiServices";

export const ProtectedRoute = () => {
    const { token } = useAuth();
    const location = useLocation();
    // Check if the user is authenticated
    if (!token) {
        // If not authenticated, redirect to the login page
        return <Navigate to="/login" state={{ from: location }} />;
    }

    // If authenticated, render the child routes
    return <Outlet />;
};

const LoginRedirectWrapper = ({ children }) => {
    const { token } = useAuth();

    if (token) {
        return <Navigate to="/individual" replace />;
    }

    return children;
};

export default LoginRedirectWrapper;

export const AccessProtectedRoute = () => {
    const [hasAccess, setHasAccess] = useState(null); // null = loading

    useEffect(() => {
        api.get("/ltm-user-existence")
            .then((res) => setHasAccess(res?.data?.exists === true))
            .catch(() => setHasAccess(false));
    }, []);

    if (hasAccess === null) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
        );
    }

    if (!hasAccess) {
        return (
            <div style={{ textAlign: "center", marginTop: "3rem" }}>
                <h2 style={{ color: "red", fontSize: "2rem", fontWeight: "bold" }}>
                    You are not authorized to view this page.
                </h2>
                <Link to="/dashboard/home" style={{
                    display: "inline-block",
                    padding: "0.75rem 1.5rem",
                    background: "#e53e3e",
                    color: "#fff",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontWeight: "bold"
                }}>
                    Go Back Home
                </Link>
            </div>
        );
    }

    return <Outlet />;
};
